export const scroll = {
  position: 'relative',
  maxHeight: '400px',
  overflowY: 'auto'
}

export const footer = { marginBottom: '10px' }
